/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Witty_Grassy_Tuna_GaspInputs */

const fr_witty_grassy_tuna_gasp = /** @type {(inputs: Witty_Grassy_Tuna_GaspInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

/**

* @param {Witty_Grassy_Tuna_GaspInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const witty_grassy_tuna_gasp = /** @type {((inputs?: Witty_Grassy_Tuna_GaspInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Witty_Grassy_Tuna_GaspInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_witty_grassy_tuna_gasp(inputs)
});